export type Map = (typeof Maps)[keyof typeof Maps];
export const Maps = {
  BASE: "Base",
  ELYSIUM: "Elysium",
  HELLAS: "Hellas",
  PLANUM_AUSTRALE: "Planum_Australe",
  SYRTIS_MAJOR: "Syrtis_Major",
  UTOPIA_PLANITIA: "Utopia_Planitia",
} as const;

export const STORAGE_BASE_URL = "https://tfmars-bucket.sfo3.digitaloceanspaces.com";

export const LOCALSTORAGE_TOKEN_KEY = "token";
const DEFAULT_BASE_URL = "https://www.tfmars.com";
export const BASE_URL = process.env.REACT_APP_BASE_URL ?? DEFAULT_BASE_URL;
